<template>
  <span>{{ getLocaleString() }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    getLocaleString() {
      if (this.value === null) {
        return '';
      }

      return this.value.toLocaleString();
    },
  },
};
</script>
